<template>
  <div
    :class="[
      'asc-container--container',
      flat ? 'asc-container--container--flat' : null,
      nested ? 'asc-container--container--nested' : null,
      floating ? 'asc-container--container--floating' : null,
    ]"
  >
    <slot name="tabs"></slot>
    <div class="asc-container--headerWrapper">
      <slot name="navLink"></slot>
      <slot name="header"></slot>
      <slot name="subheader"></slot>
    </div>
    <div class="asc-container--contentWrapper">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AscContainer',

  props: {
    flat: {
      type: Boolean,
      default: true,
    },
    nested: {
      type: Boolean,
      default: false,
    },
    floating: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
.asc-container--container {
  background-color: $primary-white;

  .asc-container--headerWrapper {
    padding: 16px 16px 0 16px;
  }

  .asc-container--contentWrapper {
    padding: 0 16px 12px 16px;
  }

  &.asc-container--container--flat {
    border: 0;
  }

  &.asc-container--container--nested {
    border: 1px solid $gray-400;
  }

  &.asc-container--container--floating {
    border: 1px solid $gray-400;
    border-radius: 0 0 2 2;

    @include container-shadow;
  }
}
</style>
